
export class EnvConfig {
    state: string;
    fallbackDev?: boolean;
}